import PropTypes from "prop-types"
import styles from "../../../styles/Login.module.css"

export default function AuthMessages({ err, msg, logoutMsg }) {
  const noDisplay = err === null && msg === null
  if (noDisplay) return null

  return (
    <div className={styles["msg-container"]}>
      {err && <div className={styles["msg-err"]}>{err}</div>}
      {msg && <div className={styles["msg-info"]}>{msg}</div>}
      {logoutMsg && <div className={styles["msg-err"]}>{logoutMsg}</div>}
    </div>
  )
}

AuthMessages.propTypes = {
  err: PropTypes.string,
  msg: PropTypes.string,
  logoutMsg: PropTypes.string,
}
